<script lang="ts" setup>
  // This starter template is using Vue 3 <script setup> SFCs
  // Check out https://vuejs.org/api/sfc-script-setup.html#script-setup
  import FoldingPanel from "../components/FoldingPanel.vue"
  import TreeItem from "../components/TreeItem.vue"
  import DropDownButton from "../components/DropDownButton.vue"
  import DropDownSplitButton from "../components/DropDownSplitButton.vue"
  import DropDownButtonItem from "../components/DropDownButtonItem.vue"
  import DropDownButtonLink from "../components/DropDownButtonLink.vue"
  import LoadingSection from "../components/LoadingSection.vue"
  import PrettyFileSize from "../components/PrettyFileSize.vue"
  import PrettyDate from "../components/PrettyDate.vue"
  import PrettyTime from "../components/PrettyTime.vue"
  import DropDownButtonDivider from "../components/DropDownButtonDivider.vue"
  import TitledRow from "../components/TitledRow.vue"
  import PageTitle from "../components/PageTitle.vue"
  import MessageSection from "../components/Messages/MessageSection.vue"
  import MessageBadge from "../components/Messages/MessageBadge.vue"
  import ModalDialog from "../components/ModalDialog.vue"
  import FilterIcon from "../components/FilterIcon.vue"
  import * as Notification from "../lib/Notification"
  import { CssLayoutUnits, CssLength } from "../lib/CssHelpers"
  import { MessageSectionType, DisplayStyle, ButtonDisplayStyle, DateDisplayFormat, LayoutOrientation, TextDisplayStyle, AlignmentTypeStyle, PaginationButtonSizeStyle, IconTypes, ToastDisplayStyles, IconFamily } from "../Enums/UiEnums"
  import { AppScreens, PrivilegeType, Alignment } from "../Enums/ChoiceEnums"
  import * as CssHelpers from "../lib/CssHelpers"
  import { ChoiceUtils } from "../LibMain"
  import CountBadge from "../components/CountBadge.vue"
  import SectionPanel from "../components/SectionPanel.vue"
  import ChoiceTable from "../components/ChoiceTable.vue"
  import { onMounted, ref, onBeforeMount, reactive, computed } from 'vue';
  import { ICol, RenderModeType } from "../lib/ChoiceTableHelpers"
  import TextInput from "../components/TextInput.vue"
  import { ValidationResults } from "../lib/Models/ValidationResults"
  import * as Conversions from "../lib/Conversions"
  import * as FormattingNumber from "../lib/Formatting/Number"
  import DatePickerNoTZ from "../components/DatePickerNoTZ.vue"
  import * as Validation from "../lib/Validation"
  import Validator from "../components/Validator.vue"
  import RadioButtonInput from "../components/RadioButtonInput.vue"
  import AccessRestrictedMsg from "../components/Messages/AccessRestrictedMsg.vue"
  import { usePrivilegesStore } from "../lib/Stores/PrivilegesStore";
  import { initPinia } from "../lib/PiniaMgr";
  import Privilege from "../components/Privilege.vue"
  import { privilegeName } from "../lib/Convert/String"
  import ActionButtonV2 from "../components/ActionButtonV2.vue"
  import { ActionButtonStyle } from "../lib/Types/Types"
  import { timeout } from "../lib/ChoiceUtils"
  import CurrencyInput from "../components/CurrencyInput.vue";
  import FloatInput from "../components/FloatInput.vue";
  import { IToolbar, ToolbarStyle, ToolbarSize, IToolbarDropDownButton, IToolbarActionButtonItem, IToolbarItem } from "../lib/Toolbar"
  import Toolbar from "../components/Toolbar.vue"
  import Checkbox from "../components/Inputs/Checkbox.vue"
  import MessageText from "../components/Messages/MessageText.vue"
  import ChoiceButton from "../components/Buttons/ChoiceButton.vue"
  import DateTimePickerNoTZ from "../components/Inputs/DateTimePickerNoTZ.vue"
  import vSelect from 'vue-select'; 
  import 'vue-select/dist/vue-select.css';
  import PaginationButtons from "../components/Pagination/PaginationButtons.vue"
  import Pagination from "../components/Pagination.vue"
  import GeneralDialog from "../components/GeneralDialog.vue"
  import ToastContainer from "../components/Messages/ToastContainer.vue"
  import { ToastItem } from "../lib/ToastItem"
  import Tab from "../components/Tab.vue"
  import PhoneInput from "../components/Inputs/PhoneInput.vue"
  import PhoneWithDetailsInput from "../components/Inputs/PhoneWithDetailsInput.vue"
import EmailInput from "../components/Inputs/EmailInput.vue"
import FoldingFieldset from "../components/FoldingFieldset.vue"
import CheckboxSwitch from "../components/Inputs/CheckboxSwitch.vue"
import Row from "../components/Section/Row.vue"
import MaterialSymbolsIcon from "../components/Icons/MaterialSymbolsIcon.vue"
import Icon from "../components/Icon.vue"
import PostalCode from "../components/Inputs/PostalCode.vue"
import GeographicStateSelect from "../components/Select/GeographicStateSelect.vue"
    import WindowSearchRendering from '../components/Search/WindowSearchRendering.vue'
    import WindowSearchPatient from '../components/Search/WindowSearchPatient.vue'
    import { WindowSearchRenderingListItem, WindowSearchPatientListItem } from '../lib/Api/WindowSearch';

  enum PageHamburger{
    Layout,
    PageOrFormItems,
    Formatting
  }

  enum TabPage
  {
    Page1 =1,
    Page2 = 2,
    Page3 = "Page 3"
  }

  const myPanelOpen = ref(true);
  const isLoadingValue = ref(true);
  const someDate = ref(new Date(2018, 5, 15));
  const showGeneralDialog = ref(false);
  const generalDialogIsModal = ref(false);
  const showModalDialog = ref(false);
  const modalDialogLog = ref<string[]>([]);
  const hideDialogSeconds = ref(0);
  const filterIconState = ref(false);
  const toastsArray = ref<ToastItem[]>([]);

  const textInputValue = ref("testing...");
  const multiLineInputValue = ref("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eu neque id lorem lacinia aliquet. Sed convallis ut arcu vel pretium. Mauris sodales felis accumsan, faucibus lacus ut, lobortis est. Aliquam dapibus consectetur lorem, vitae ultrices est blandit non. Suspendisse scelerisque semper commodo. Aliquam rhoncus sem sem, at tincidunt erat condimentum a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam risus massa, molestie nec neque sed, posuere lacinia justo. Proin justo lectus, ornare in ultrices quis, rutrum sed diam. Donec augue augue, posuere eu tincidunt eu, tempor id mi. Donec dictum vel lectus vel posuere. Nam semper mauris quis vulputate venenatis. Quisque vitae nunc in risus ultricies tempor. Morbi mattis dictum luctus.");
  const textNegativeNumberValue = ref<number>(-12345667);
  const datePickerValue = ref<Date>(new Date(1945, 5, 8));
  const dateWithoutTimeZonePickerValue = ref<string|undefined>("Jan 1, 2022 13:50:00");
  const validateSection = ref();
  const checkbox1Value = ref(true);
  const checkbox2Value = ref(false);
  const checkbox3Value = ref();

  const checkboxSwitchValue = ref();

  const radioButtonGroupValue = ref<string|number|undefined>("two");
  const horizButtonGroupValue = ref();
  const privilegesStore = usePrivilegesStore(initPinia());
  const requiredPrivilege=ref(PrivilegeType.ReadUpdateWrite);
  const userPrivilege = ref(PrivilegeType.Read);
  const testCurrencyNumber = ref(123.22);
  const testFloatNumber = ref(345.87);
  const toolbarResults = ref<string>("");
  const currentTab = ref<TabPage>(TabPage.Page1);
  const userEmail = ref("Wet@Dog.com");
  const phoneNumber10Digits = ref<string>("(865) 555-1212");
  const phoneNumberWithExt = ref({phone: "423 555-1212", ext: "1234", desc: "Mom"});

  const compData = reactive<{
    dateTimePicker:
    {
      first: string, 
      second: string, 
      third: string
    },
    currentTopItem: number,
    currentTopItemPag: number,
    searchRenderingValue: WindowSearchRenderingListItem | null,
    searchPatientValue: WindowSearchPatientListItem | null,

  }>({
      currentTopItem: 0,
      currentTopItemPag: 0,

      dateTimePicker:
      {
        first: "9/12/2004 1:12:13 am",
        second: "Jan 12, 2007 13:12:13",
        third: "Jan 12, 2007 4:12:13 pm",
      }
  });

  enum myToolbar {
        search, 
        setup,
        save,
        audit,
        mainMenu,
        menu1,
        menu2,
        searchAgain
    }

  // Define tooltip items
  const myToolbarMainMenu = ref<IToolbarDropDownButton>({
      identifier: myToolbar.mainMenu, label: "Menu", action: ActionButtonStyle.Edit, 
      menuList:[
        {identifier: myToolbar.menu1, label: "Disable Setup"},
        {identifier: myToolbar.menu2, label: "Disable Save"}
      ]});
  const myToolbarSetup = ref<IToolbarActionButtonItem>({identifier: myToolbar.setup, label: "Setup",tooltip: "This is a setup button", enabled: true, performAction: async () => { Notification.popAlert("Setup button clicked"); }});
  const myToolbarSave = ref<IToolbarItem>({identifier: myToolbar.save, label: "", action: ActionButtonStyle.Save, tooltip: "Save"});

  // Collect the tooltip items into a tooltip configuration object
  const toolbarConfiguration = computed<IToolbar>(() => ({toolbarList: [
      {identifier: myToolbar.search, tooltip: "This is a search control with delay", enabled: true, search: {keyPressDelay: true, placeholder: "search delay", maxLength: 200}},
      myToolbarSetup.value,
      myToolbarSave.value,
      {identifier: myToolbar.audit, action: ActionButtonStyle.Audit, performAction: () => Notification.popAlert("Audit button clicked")},
      myToolbarMainMenu.value,
      {identifier: myToolbar.searchAgain, tooltip: "This is a search control with no delay", enabled: true, search: {keyPressDelay: false, placeholder: "search no delay"}}
  ]}));


  const checkboxForActionButtonValidation = ref(false);
  
  // Not sure how to indicate we're using the ChoiceTable component so using 'any' ;(
  const testTable = ref<InstanceType<typeof ChoiceTable>>();

  const myTreeItems = ref({
      name: "Pets",
      children: [
          {
              name: "Dog",
              children: [{ name: "Fido" }, { name: "Lassie" }, { name: "Sam" },
              ]
          },
          {
              name: "Cat",
              children: [{ name: "Parker" }, { name: "Sox" }, { name: "Shoes" }, { name: "Ray" }, { name: "Chip" },]
          },
          { name: "Bird" }
      ]
  });

  const tableColumns = ref<ICol[]>([
    { Name: '', DataField:"selected", RenderMode: RenderModeType.Selection },
    { Name: 'Col1', DataField: 'Col1Name' },
    { Name: 'ColTwo', DataField: 'Col2' },
    { Name: 'Col Threeee', DataField: 'Col3Val' },
  ]);

    const tableData = ref([
      {selected: true, Col1Name: "A", Col2: 1, Col3Val: "A1" },
      {selected: true, Col1Name: "AA", Col2: 1, Col3Val: "AA1" },
      {selected: true, Col1Name: "B", Col2: 1, Col3Val: "B1" },
      {selected: true, Col1Name: "B", Col2: 2, Col3Val: "B2" },
      {selected: true, Col1Name: "C", Col2: 10, Col3Val: "C-10" },
      {selected: true, Col1Name: "D", Col2: 11, Col3Val: "D-11" },
      {selected: true, Col1Name: "E", Col2: 1, Col3Val: "E1" }
    ]);

  type DropDownDataType = {finClassId:number, finClassDescription:string}
  const dropDownData = ref<DropDownDataType[]>([
    {finClassId: 1, finClassDescription: 'Aetna'},
    {finClassId: 2, finClassDescription: 'Blue Cross/Blue Shield'},
    {finClassId: 3, finClassDescription: 'Cigna'},
    {finClassId: 4, finClassDescription: 'Medicaid'},
    {finClassId: 5, finClassDescription: 'Medicare'},
    {finClassId: 9, finClassDescription: 'Medicare Replacement'},    
    {finClassId: 11, finClassDescription: 'Commercial'},
    {finClassId: 12, finClassDescription: 'SelfPay'}
  ]);

  const postalCode = ref<string>("12345-6789");
  const stateOrProvince = ref<string>("TN");

  const finClassDropDownSelectionsSingle = ref();
  const finClassDropDownSelectionsMultiple = ref();


    onBeforeMount(() =>{
      privilegesStore.screens[AppScreens.Deposit] = userPrivilege.value;
    });

    onMounted(() =>{
        setInterval(() => {
            isLoadingValue.value = !isLoadingValue.value;
        }, 2000);
    })

    function onClickedTreeItem(treeItem: any) {
        window.alert(`Item clicked: ${JSON.stringify(treeItem)}`);
    }
    function onClickedDropDownButton() {
        window.alert("Clicked drop down button");
    }
    function onClickedDropDownItem(id: any) {
        window.alert("Drop down button clicked: " + id);
    }
    function showDialogAndStartHideCountdown() {
        hideDialogSeconds.value = 2;
        showModalDialog.value = !showModalDialog.value;
        monitorHideDialogStatus();
    }
    async function monitorHideDialogStatus() {
        await ChoiceUtils.timeout(1000);
        if (hideDialogSeconds.value > 0) {
            hideDialogSeconds.value = hideDialogSeconds.value - 1;
            monitorHideDialogStatus();
            return;
        }
        showModalDialog.value = false;
    }

    async function showConfirmationDialog() {
        const result = await Notification.confirmDialog("Show an <b>important</b> message...");
        alert("Confirmation Result: " + result);
    }

    function ExportTableToExcel() {
      testTable.value?.exportToExcel("SomeFilename.xls", "Cut the Sheet");
    }

    function NegativeNonZeroNumber_WithMessage(value: number): ValidationResults
    {
        if (value < 0)
          return {isValid: true};
          
        return { isValid: false, errorMsg: "Must be a negative value"};
    }

    function LimitToFloatAndMinus(char: string): boolean
    {
      if ("-" === char || "." === char)
        return true;

      return Validation.LimitToNumberCharacters(char);
    }

    async function delayTwoSeconds(): Promise<void>
    {
      await timeout(2*1000);
    }

    async function confirmSpy(): Promise<boolean>
    {
      const res = await Notification.confirmDialog('Do you work for the CIA?', {ConfirmText: "Confirm", RejectText: "Deny"});
      if (!res)
        Notification.popAlert("Rejected before it was started!");
      return res;
    }

    async function ToolbarClick(data: myToolbar): Promise<void> {
        toolbarResults.value = `ToolbarClick: ${myToolbar[data]}`;
        if (data == myToolbar.menu1) {
          myToolbarSetup.value.enabled = !myToolbarSetup.value.enabled;
          myToolbarMainMenu.value.menuList[0].label = myToolbarSetup.value.enabled ? "Disable Setup Button" : "Enable Setup Button";
        }
        else if (data == myToolbar.menu2) {
          myToolbarSave.value.enabled = !myToolbarSave.value.enabled;
          myToolbarMainMenu.value.menuList[1].label = myToolbarSave.value.enabled ? "Disable Save" : "Enable Save";
        }
        else 
        {
          await Notification.popAlert(`Toolbar clicked -- identifier/data value is: ${data}`);
        }
    }
    async function ToolbarSearchText(data: myToolbar, searchResult: string): Promise<void> {
      toolbarResults.value = `ToolbarSearchText: ${data}: ${searchResult}`;
    }

    async function updateSingleSelect() {
      alert("Call function to do some update based on drop down selection");
    }

    function addToast(displayStyle: ToastDisplayStyles)
    {
      const newToast = new ToastItem("Sample Toast", `Some simple/short message @ ${new Date().toTimeString()}`, displayStyle);

      // Hide the action link for success messages
      if (DisplayStyle.Success === displayStyle)
        newToast.showActionLink = false;

      toastsArray.value.push(newToast);
    }
</script>

<!-- This is a gallery of basic components -->
<template>
    <PageTitle :bottom-margin="CssLength.em(1)">
    <template #title>Choice.ClientLib</template>
    <template #subtitle>
      This is the page sub-title
    </template>
    <template #farright>
      <DropDownButton :display-style="ButtonDisplayStyle.Link">
        <DropDownButtonItem :data="PageHamburger.Layout" @click="Notification.popAlert('Show some info')">Page Layout Examples</DropDownButtonItem>
        <DropDownButtonItem :data="PageHamburger.PageOrFormItems" @click="onClickedDropDownItem">Page/Form Items</DropDownButtonItem>
        <DropDownButtonItem :data="PageHamburger.Formatting" @click="onClickedDropDownItem">Data Formatting</DropDownButtonItem>
      </DropDownButton>
    </template>
  </PageTitle>
  
  <div class="container-fluid">
    <div class="row">

      <SectionPanel title="TextInput & Validator">
        <div>
          <TitledRow title="Simple Text">
            <TextInput 
              v-model:text-value="textInputValue" 
              :required="true"
              @validationState="(state, msg) => validateSection?.sinkValidation('Simple Text', state, msg)"
              :suffixIcon="IconTypes.XMark"
              @suffixIconClicked="Notification.popAlert('X icon clicked')"
              />
          </TitledRow>

          <TitledRow title="Integer > 0 (No message, with Formatting)">
            <TextInput v-model:textValue="textNegativeNumberValue" 
                :formatter="(val:any) => FormattingNumber.NumberToLocaleString(val)"
                :normalizer="Conversions.TextToNumber" 
                :validator="Validation.InRangeFunction(1, undefined)"
                :acceptCharacter="Validation.LimitToNumberCharacters"
                @validationState="(state, msg) => validateSection?.sinkValidation('Integer > 0', state, msg)">  
                <template #LeftAddon>
                  <em class="fa-solid fa-gift ms-1"/>
                </template>
                <template #RightAddon>
                  At least one gift!!
                </template>
            </TextInput>
          </TitledRow>

          <TitledRow title="Number < 0 (With message)">
            <TextInput v-model:textValue="textInputValue" 
                :normalizer="Conversions.TextToNumber" 
                :validator="NegativeNonZeroNumber_WithMessage"
                :acceptCharacter="LimitToFloatAndMinus" 
                @validationState="(state, msg) => validateSection?.sinkValidation('Number < 0', state, msg)" />  
          </TitledRow>

          <TitledRow title="Vanilla CSS">
            <TextInput v-model:textValue="textInputValue" cssFramework="vanilla" />  
            <em>
              Example of non-Bootstrap input
            </em>
          </TitledRow>

          <TitledRow title="MultiLine">
            <TextInput :rows="3" v-model:textValue="multiLineInputValue" />
          </TitledRow>          
        </div>

        <Validator ref="validateSection"></Validator>

      </SectionPanel>

      <SectionPanel title="CurrencyInput">
        <TitledRow title="Charge per Unit">
              <CurrencyInput 
                  v-model:numberValue="testCurrencyNumber"
                  :startingRange=0
                  :endingRange=99999.99
                  :positive=true
                  :required=true
                  :alignment=Alignment.left
                  placeholder="Charge amount" 
                  :error-display="true"    
              />
          </TitledRow>
      </SectionPanel>  

      <SectionPanel title="FloatInput">
        <TitledRow title="Amount">
              <FloatInput 
                  v-model:numberValue="testFloatNumber"
                  :startingRange=0
                  :endingRange=999999.99
                  :positive=true
                  :required=true
                  :alignment=Alignment.left
                  placeholder="Enter amount" 
                  :error-display="true"    
              />
          </TitledRow>
      </SectionPanel>  

      <SectionPanel title="Section">
        This is a section with some content
      </SectionPanel>

      <SectionPanel title="PageTitle">
        <PageTitle>
          <template #title>Page Title</template>
          <template #subtitle>Use for the top of each page</template>
          <template #farright>
            <i class="fa-solid fa-bars" aria-hidden="true" @click="Notification.popAlert('Do something')"></i>
          </template>
        </PageTitle>

          You can Override normal button using the 'button' slot and providing content like:
            <div style="margin-left:2em">
              &lt;i class="fa-solid fa-bolt-lightning fa-xl mt-2" aria-hidden="true"&gt;&lt;/i&gt;
            </div>
      </SectionPanel>

      <SectionPanel title="ChoiceTable">
        <div class="row">
          <ChoiceTable 
              ref="testTable"
              :columns="tableColumns" 
              :data="tableData" 
              :show-filters="true" 
              :allowSorting="true"
              :key-value-data-member="'Col3Val'" />
          <div class="float-end">
            <button class="btn btn-primary me-1" @click="ExportTableToExcel">
              Excel
            </button>

            <!--             
              FUTURE: Add jsPDF support to the gallery
              <button class="btn btn-primary me-1" @click="() => testTable?.convertToPdf('TheFileName.pdf')">
                PDF
              </button> 
            -->
          </div>
        </div>
        <br/>

        <div>
          Height limited, smaller font size, filter off
        </div>
        <ChoiceTable 
            :columns="tableColumns" 
            :data="tableData" 
            :allowSorting="true"
            font-size="smaller"
            :height="{amount: 12, units: CssLayoutUnits.em}"
            :key-value-data-member="'Col3Val'" />
      </SectionPanel>

      <SectionPanel title="General Dialog">
        <GeneralDialog v-model:show="showGeneralDialog" :isModal="generalDialogIsModal">
          <template #title>
            Dialog Title
          </template>
          <p>Greetings, one and all!</p>
          <template #footer>
            Dialog Footer
          </template>
        </GeneralDialog>
        <button type="button" @click="generalDialogIsModal = true; showGeneralDialog = !showGeneralDialog;" class="btn btn-primary btn-sm me-1">Show Modal</button>
        <button type="button" @click="generalDialogIsModal = false; showGeneralDialog = !showGeneralDialog;" class="btn btn-primary btn-sm">Show Non-Modal</button>
      </SectionPanel>

      <SectionPanel title="ModalDialog">
        <ModalDialog v-model:show="showModalDialog" @shown="modalDialogLog.unshift('Dialog shown')" @hidden="modalDialogLog.unshift('Dialog hidden')" @hide="Notification.confirmDialog('Some message');">
          <template #title>Dialog Title</template>
          Dialog body
          <template #footer>
            Dialog Footer
            <MessageBadge :display-style="DisplayStyle.Secondary">this is optional</MessageBadge>
          </template>
        </ModalDialog>

        <div v-if="modalDialogLog.length > 0">
          Event Log
          <button type="button" class="btn btn-primary btn-sm" @click="modalDialogLog = []">
            <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
          </button>
          <ul>
            <li v-for="logEntry of modalDialogLog">
              {{logEntry}}
            </li>
          </ul>
        </div>

        <div>
          <MessageBadge :display-style="showModalDialog ? DisplayStyle.Danger : DisplayStyle.Secondary">
            showModalDialog: {{showModalDialog}}
          </MessageBadge>
        </div>

        <button type="button" class="btn btn-primary" @click="showModalDialog = !showModalDialog" v-if="!showModalDialog">
          Show Dialog
        </button>

        <button type="button" class="btn btn-info ms-1" @click="showDialogAndStartHideCountdown" v-if="!showModalDialog">
          Show Dialog and close in 10 seconds
        </button>
        <div v-if="showModalDialog">
          <MessageSection>
            Hiding dialog in {{hideDialogSeconds}} seconds...
          </MessageSection>
        </div>
      </SectionPanel>

      
      <SectionPanel title="Toast">
        <ToastContainer :toasts="toastsArray" 
            :defaultHideDelayMilliseconds="10000"
            :warnIfMessageLibNotAvailable="false"
            @resizedToasts="size => console.log(size)"
            @clickedAction="toastItem => Notification.popAlert(`The toast ID is: ${toastItem.id} with a title of ${toastItem.title}. The data value is ${toastItem.data}`)"
            />

        <button type="button" class="btn btn-primary me-1" @click="addToast(DisplayStyle.Info)">Show Info Toast</button>
        <button type="button" class="btn btn-danger me-1" @click="addToast(DisplayStyle.Danger)">Show Danger Toast</button>
        <button type="button" class="btn btn-warning me-1" @click="addToast(DisplayStyle.Warning)">Show Warning Toast</button>
        <button type="button" class="btn btn-success me-1" @click="addToast(DisplayStyle.Success)">Show Success Toast</button>
      </SectionPanel>

      <SectionPanel title="DropDownButton">
        <DropDownButton>
          <template #button>
            <i class="fa-regular fa-user" aria-hidden="true"></i> Settings
          </template>
          <DropDownButtonItem data="Profile" @click="onClickedDropDownItem">Profile</DropDownButtonItem>
          <DropDownButtonItem data="Theme" @click="onClickedDropDownItem">Theme</DropDownButtonItem>
          <DropDownButtonDivider/>
          <DropDownButtonLink href="//www.vuejs.org/" target="_blank">Vue Site</DropDownButtonLink>
        </DropDownButton>

        <DropDownButton>
          <DropDownButtonItem data="Item A" @click="onClickedDropDownItem">Item A</DropDownButtonItem>
          <DropDownButtonItem data="Item b" @click="onClickedDropDownItem">Item B</DropDownButtonItem>
          <DropDownButtonDivider/>
          <DropDownButtonItem data="Item Sea" @click="onClickedDropDownItem">Item C</DropDownButtonItem>
          <DropDownButtonDivider/>
          <DropDownButtonItem @click="Notification.popAlert('Another thing...')">And another thing</DropDownButtonItem>
        </DropDownButton>

      </SectionPanel>

      <SectionPanel title="DropDownSplitButton">

        <DropDownSplitButton buttonTitle="Do Default!" @onButtonClick="onClickedDropDownButton">
          <DropDownButtonItem data="Item A" @click="onClickedDropDownItem">Item A</DropDownButtonItem>
          <DropDownButtonItem data="Item b" @click="onClickedDropDownItem">Item B</DropDownButtonItem>
          <DropDownButtonDivider/>
          <DropDownButtonItem data="Item Sea" @click="onClickedDropDownItem">Item C</DropDownButtonItem>
        </DropDownSplitButton>

      </SectionPanel>      


      <SectionPanel title="Folding Panel">
          <FoldingPanel :panel-open="myPanelOpen">
            <template #title>
              My Panel
            </template>
            
            <template #body>
              <p>
                Some other info....<br/>
              </p>
            </template>
          </FoldingPanel>

          <FoldingPanel :panel-open="myPanelOpen" :displayStyle="DisplayStyle.Danger">
            <template #title>
              Danger Style panel
            </template>
            
            <template #body>
              Error Info
            </template>
          </FoldingPanel>          

          <div style="padding-top:0.5em">
            <button type="button" class="btn btn-sm btn-primary" @click="() => myPanelOpen = !myPanelOpen">External Toggle</button>
          </div>
      </SectionPanel>

      <SectionPanel title="FoldingFieldset">
        <FoldingFieldset title="Title">
            Content
        </FoldingFieldset>
      </SectionPanel>

      <SectionPanel title="LoadingSection">
        <LoadingSection :isLoading="isLoadingValue" loadingMsg="Loading data...">
            <div class="badge bg-primary">Loaded (Will toggle back to loading in a moment)</div>
        </LoadingSection>
        <div>
          isLoading: {{isLoadingValue}}
        </div>
      </SectionPanel>


      <SectionPanel title="TreeItem">
        <TreeItem :treeItem="myTreeItems" @onItemClick="(item: any) => onClickedTreeItem(item)">
          <template #item="{treeItem}">
              <button type="button" class="btn btn-sm btn-primary">Click Me</button> {{treeItem?.name}}
          </template>
        </TreeItem>      
      </SectionPanel>

      <SectionPanel title="PrettyFileSize">
        <div>
          <small class="text-muted">File A:</small> <PrettyFileSize :bytes="1245"></PrettyFileSize>
        </div>
        <div>
          <small class="text-muted">File B:</small> <PrettyFileSize :bytes="2901010"></PrettyFileSize>
        </div>
      </SectionPanel>

      <SectionPanel title="PrettyDate">
        <div>
          <PrettyDate date="Jan 5, 2021" :showTime="false"/>
        </div>
        <div>
          <PrettyDate :date="someDate" :showTime="false"/>
        </div>
      </SectionPanel>

      <SectionPanel title="PrettyTime">
        <div>
          <PrettyTime date="Jan 5, 2021 13:00:01"/> <span class="text-muted">
          (In EST/EDT it should be Should be 1:00:01 PM EDT)</span>
        </div>
        <div>
          <PrettyTime :date="new Date()"/>
        </div>
        <br/>

        Military time
        <div>
          <PrettyTime :date="new Date('Jan 1, 2021 01:02:11')" :militaryTime="true"/>
        </div>
        <div>
          <PrettyTime :date="new Date('Jan 1, 2021 17:31:22')" :militaryTime="true"/>
        </div>
      </SectionPanel>      

      <SectionPanel title="DatePickerNoTZ">
        <div>
          For the legacy OfficeMD system, our best option is to treat most dates as values without a timezone
        </div>
        <DatePickerNoTZ v-model:value="dateWithoutTimeZonePickerValue" :displayFormat="DateDisplayFormat.NumericDashDate" @update:value="evt => console.log(`Update: ${evt}`)" />
        <div>
          Date Only Text: <MessageBadge>{{dateWithoutTimeZonePickerValue ?? "(undefined)"}}</MessageBadge>
        </div>
      </SectionPanel>

      <SectionPanel title="DateTimePickerNoTZ">
          <div class="row">
            <div class="col-sm-6">
              <DateTimePickerNoTZ v-model="compData.dateTimePicker.first" />
            </div>
            <div class="col-sm-6">
              Current Value: {{ compData.dateTimePicker.first }}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-6">
              <DateTimePickerNoTZ v-model="compData.dateTimePicker.second" />
            </div>
            <div class="col-sm-6">
              Current Value: {{ compData.dateTimePicker.second }}
            </div>
          </div>          

          <div class="row">
            <div class="col-sm-6">
              <DateTimePickerNoTZ v-model="compData.dateTimePicker.third" />
            </div>
            <div class="col-sm-6">
              Current Value: {{ compData.dateTimePicker.third }}
            </div>
          </div>                    
      </SectionPanel>

      <SectionPanel title="TitledRow">
          <TitledRow title="Item A" :titleWidth="3">
            A-List
          </TitledRow>
          <TitledRow title="Item B" :titleWidth="4">
            Bee movie
          </TitledRow>        
          <TitledRow title="Item C" :titleWidth="5">
            Sea Shore <span class="badge badge-primary">Summer</span>
          </TitledRow>
      </SectionPanel>

      <SectionPanel title="MessageSection">
        <MessageSection :show-icon="true" :type="MessageSectionType.Text" :display-style="DisplayStyle.Danger">
          Danger/Error Msg (as text)
        </MessageSection>

        <div style="border: purple 1px dashed; margin: 1em; padding: 0.5em;">
          <MessageSection :show-icon="false" :type="MessageSectionType.Text" :display-style="DisplayStyle.Warning">
            Warning Msg (as text)
          </MessageSection>        
        </div>


        <MessageSection :type="MessageSectionType.Row">
          Primary/(Default Case) Msg (as row)
        </MessageSection>
        <MessageSection :type="MessageSectionType.Row" :display-style="DisplayStyle.Danger">
          Danger Msg (as row)
        </MessageSection>        
        <MessageSection :type="MessageSectionType.Row" display-style="warning">
          Warning Msg (as row)
        </MessageSection>        

      </SectionPanel>

      <SectionPanel title="MessageBadge">
          <MessageBadge :display-style="DisplayStyle.Warning">
            My Warning Badge
          </MessageBadge>
          <MessageBadge :display-style="DisplayStyle.Danger">
            My Danger Badge
          </MessageBadge>
          <MessageBadge :display-style="DisplayStyle.Primary">
            My Primary Badge
          </MessageBadge>
      </SectionPanel>

      <SectionPanel title="CountBadge">
        <CountBadge :count="2" :positiveDisplayStyle="DisplayStyle.Success" />
        <CountBadge :count="1" />
        <CountBadge :count="0" />
        <CountBadge :count="-1" />
        <CountBadge :count="-2" :negativeDisplayStyle="DisplayStyle.Danger" />
      </SectionPanel>

      <SectionPanel title="FilterIcon">
        <FilterIcon 
          v-model:on="filterIconState"
          titleFilterOn="Click to clear filter"
          titleFilterOff="Click to enable filter"
          @change="(filterState: boolean) => Notification.popAlert('Filter ' + (filterState ? 'on':'off'))">
        </FilterIcon>

          <MessageBadge :display-style="filterIconState ? DisplayStyle.Success : DisplayStyle.Danger" class="ms-3">
            Filter State: {{filterIconState ? "On" : "Off"}}
          </MessageBadge>
      </SectionPanel>
      
      <SectionPanel title="ChoiceUtils.confirmDialog">
        <button type="button" @click="showConfirmationDialog" class="btn btn-primary">
          Show Confirmation Dialog
        </button>
      </SectionPanel>

      <SectionPanel title="Checkbox">
        <div>
          <Checkbox v-model="checkbox1Value" /> Check1 
          <MessageText :displayStyle="TextDisplayStyle.Muted"></MessageText>({{ checkbox1Value }})
        </div>
        <div>
          <Checkbox v-model="checkbox2Value" /> Check2 
          <MessageText :displayStyle="TextDisplayStyle.Muted"></MessageText>({{ checkbox2Value }})
        </div>
        <div>
          <Checkbox v-model="checkbox3Value" /> Check3 
          <MessageText :displayStyle="TextDisplayStyle.Muted"></MessageText>({{ checkbox3Value }})
        </div>                
      </SectionPanel>

      <SectionPanel title="CheckboxSwitch">
        <CheckboxSwitch 
            v-model="checkboxSwitchValue"
            defaultMessage="Off"
            switchedMessage="On" />

          <CheckboxSwitch 
            v-model="checkboxSwitchValue"
            defaultMessage="Off"
            switchedMessage="On">
            <template #checked>
              <MessageBadge :displayStyle="DisplayStyle.Success">On</MessageBadge>
            </template>
            <template #unchecked>
              <MessageBadge :displayStyle="DisplayStyle.Danger">Off</MessageBadge>
            </template>
          </CheckboxSwitch>
          
          Check value: {{ checkboxSwitchValue ?? "undefined" }}
      </SectionPanel>


      <SectionPanel title="RadioButtonInput">
        <div class="text-muted">Vert Layout</div>
        <RadioButtonInput value="one" v-model="radioButtonGroupValue">Option 1</RadioButtonInput>
        <RadioButtonInput value="two" v-model="radioButtonGroupValue" :layout="LayoutOrientation.Vert">Option 2</RadioButtonInput>
        <RadioButtonInput value="three" v-model="radioButtonGroupValue" :disabled="true">Option 3</RadioButtonInput>
        <RadioButtonInput value="four" v-model="radioButtonGroupValue">Option 4</RadioButtonInput>

        <MessageSection :display-style="DisplayStyle.Info" :show-icon="false">
          Group Value: {{ radioButtonGroupValue }}
        </MessageSection>

        <div class="text-muted">Horiz Layout</div>
        <RadioButtonInput value="Wanda" v-model="horizButtonGroupValue" :layout="LayoutOrientation.Horz">Fish</RadioButtonInput>
        <RadioButtonInput value="Scooby" v-model="horizButtonGroupValue" :layout="LayoutOrientation.Horz">Dog</RadioButtonInput>
        <RadioButtonInput value="Bill the Cat" v-model="horizButtonGroupValue" :layout="LayoutOrientation.Horz">Cat</RadioButtonInput>

        <MessageSection :display-style="DisplayStyle.Info" :show-icon="false">
          Horiz Group Value: {{ horizButtonGroupValue }}
        </MessageSection>        

      </SectionPanel>

      <SectionPanel title="ChoiceButton">
        <ChoiceButton :action="ActionButtonStyle.Add" :displayStyle="DisplayStyle.Primary" />
        <ChoiceButton :action="ActionButtonStyle.Calendar" :displayStyle="DisplayStyle.Info" />
        <ChoiceButton :action="ActionButtonStyle.Close" :displayStyle="DisplayStyle.Danger" />
        <ChoiceButton :action="ActionButtonStyle.Save" :displayStyle="ButtonDisplayStyle.OutlineSuccess" />

        <ChoiceButton :displayStyle="ButtonDisplayStyle.TextPrimary">Text Button</ChoiceButton>
      </SectionPanel>

      <SectionPanel title="ActionButtonV2">
        <div class="mb-1">
          <ActionButtonV2 :action="ActionButtonStyle.Add" :performAction="delayTwoSeconds" />
          Simple button without validation and using default settings
        </div>

        <div class="mb-1">
          <ActionButtonV2 :action="ActionButtonStyle.Edit" :onBeforeActionValidate="confirmSpy" :performAction="delayTwoSeconds" />
          Button that check if the user agrees in the dialog
        </div>

        <div class="mb-1">
          <ActionButtonV2 :action="ActionButtonStyle.Edit" :width="{amount: 15, units: CssHelpers.CssLayoutUnits.ex}" :performAction="delayTwoSeconds" />
          A button with a width of 15ex
        </div>

        <div class="mb-1">
          <ActionButtonV2 :action="ActionButtonStyle.Search" :performAction="delayTwoSeconds">
            Rich content 
            <svg title="Noun Project home" width="84" height="23" viewBox="0 0 84 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M50.8421 4.55325L46.8133 0.483887L39.7895 7.56844L32.6983 0.483887L28.7368 4.55325L35.755 11.5698L28.7368 18.592L32.6983 22.6557L39.7895 15.5711L46.8133 22.6557L50.8421 18.592L43.8239 11.5698L50.8421 4.55325ZM20.0445 17.9056C23.5054 12.8967 22.2627 6.02212 17.2688 2.55081C12.275 -0.920494 5.42106 0.325967 1.96017 5.33486C-1.50072 10.3438 -0.257997 17.2183 4.73587 20.6896C9.72973 24.1609 16.5837 22.9145 20.0445 17.9056ZM84 0.483887H61.8947V22.6557H84V0.483887Z" fill="#000000"></path>
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="84" height="23">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M50.8421 4.55325L46.8133 0.483887L39.7895 7.56844L32.6983 0.483887L28.7368 4.55325L35.755 11.5698L28.7368 18.592L32.6983 22.6557L39.7895 15.5711L46.8133 22.6557L50.8421 18.592L43.8239 11.5698L50.8421 4.55325ZM20.0445 17.9056C23.5054 12.8967 22.2627 6.02212 17.2688 2.55081C12.275 -0.920494 5.42106 0.325967 1.96017 5.33486C-1.50072 10.3438 -0.257997 17.2183 4.73587 20.6896C9.72973 24.1609 16.5837 22.9145 20.0445 17.9056ZM84 0.483887H61.8947V22.6557H84V0.483887Z" fill="#000000"></path>
              </mask>
            </svg>
          </ActionButtonV2>
          A button with rich content
        </div>

        <div class="mb-1">
          <ActionButtonV2 :action="ActionButtonStyle.InvoiceDollar" :performAction="delayTwoSeconds">
            <i class="fa-solid fa-dollar-sign"></i>
            Need <b style="color:greenyellow">Money</b>
            <template #executing>
              <i class="fa-solid fa-dollar-sign fa-spin"></i>
              Checking my pockets
            </template>
          </ActionButtonV2>
          A button with rich content
        </div>        

      </SectionPanel>

      <SectionPanel title="Toolbar">
        <div><hr3>Standard</hr3></div>
        <div class="mb-1">
            <Toolbar 
              :configuration="toolbarConfiguration" 
              :toolbarSize="ToolbarSize.regular" 
              :toolbarStyle="ToolbarStyle.outline" 
              @toolbarClick="ToolbarClick"  
              @toolbarSearchText="ToolbarSearchText"/>
        </div>
        <div class="mb-1">
          {{ toolbarResults }}
        </div>
        <div class="mt-2 mb-2"><hr3>OfficeMdStyle <b><i>NOTE: Styling / highlights / events are currently only partially implemented.</i></b></hr3></div>
        <div style="border: 1pt #6a8ccb solid; background-color: #dbebff; border-collapse: collapse;" 
          class="ms-1 me-1 mb-1 row mdtoolbarheader d-flex align-self-center">
            <Toolbar 
              :configuration="toolbarConfiguration" 
              :toolbarSize="ToolbarSize.regular" 
              :toolbarStyle="ToolbarStyle.outline" 
              :styleAsOfficeMd="true"
              @toolbarClick="ToolbarClick"  
              @toolbarSearchText="ToolbarSearchText"/>
        </div>
      </SectionPanel>

      <SectionPanel title="AccessRestrictedMsg">
        <div class="mb-2">
          <MessageBadge>Example 1</MessageBadge>
          Restricted Screen:
          <AccessRestrictedMsg :rights="{ screen: AppScreens.BillerAction, userPrivilege: PrivilegeType.Read, requiredPrivilege: PrivilegeType.ReadUpdateWrite }"/>
        </div>

        <div class="mb-2">
          <MessageBadge>Example 2</MessageBadge>
          Not Restricted (logic in message prevents display):
          <AccessRestrictedMsg :rights="{ screen: AppScreens.DefaultComments, userPrivilege: PrivilegeType.ReadUpdate, requiredPrivilege: PrivilegeType.Read }">
            <template #message>
              Off Limits
            </template>
          </AccessRestrictedMsg>
          <div class="text-muted">There is a component above that isn't visible due to rights being met.</div>
        </div>

        <div class="mb-2">
          <MessageBadge>Example 3</MessageBadge>
          Just a restricted message without screen or rights info:
          <AccessRestrictedMsg/>
        </div>

      </SectionPanel>

      <SectionPanel title="Privilege (used with Privileges store)">
        <div>
          Min Component Privilege: 
          <select v-model="requiredPrivilege">
            <option :value="PrivilegeType.None">None</option>
            <option :value="PrivilegeType.Read">Read</option>
            <option :value="PrivilegeType.ReadUpdate">Read/Update</option>
            <option :value="PrivilegeType.ReadUpdateWrite">Read/Update/Write</option>
          </select>
          <span class="ms-1 text-muted">(change to update the minimum privilege for components below)</span>
        </div>
        <div>
          User right: {{ privilegeName(userPrivilege) }} 
          <span class="ms-1 text-muted">(from store)</span>
        </div>
        <br/>

        <div class="mb-2">
          <div class="mb-2">
            
            <div>
              <MessageBadge>Example 1</MessageBadge>
              Low code/standard restriction message
            </div>
            <Privilege :screen="AppScreens.Deposit" :privilege="requiredPrivilege" :showRestriction="true">
              <div class="alert alert-success">
                <span style='font-size:12pt;'>&#128513;</span>
                User has rights to view!
              </div>
            </Privilege>
          </div>
  

          <div>
            <MessageBadge>Example 2</MessageBadge>
            custom message when restricted
          </div>
          <Privilege :screen="AppScreens.Deposit" :privilege="requiredPrivilege">
              <span class="text-success">
                Displayed when access allowed
              </span>
              <template #notAllowed>
                <span class="text-danger">
                  Custom message we display when user rights restrict access
                </span>
              </template>
          </Privilege>
        </div>

      </SectionPanel>

      <SectionPanel title="Single-Select Drop Down with Vue-Select">
        <div class="mb-1 row">
          <div class="row pb-2"><a href="https://vue-select.org/" target="_blank">https://vue-select.org/</a></div>
          <div class="row pb-2 ps-4">This control allows you to enter a search term.</div>
          <div class="col col-sm-3">            
            <v-select                     
                style="font-size: 0.95rem"
                v-model="finClassDropDownSelectionsSingle"
                :options="dropDownData" 
                @option:selected="updateSingleSelect"
                @option:deselected="updateSingleSelect"
                :reduce="(item:DropDownDataType) => item.finClassId" label="finClassDescription" />
          </div>
        </div>
        <div class="mb-1">
          Drop Down Selection: {{ finClassDropDownSelectionsSingle }}
        </div>
      </SectionPanel>

      <SectionPanel title="Multi-Select Drop Down with Vue-Select">
        <div class="mb-1 row">
          <div class="row pb-2"><a href="https://vue-select.org/" target="_blank">https://vue-select.org/</a></div>
          <div class="row pb-2 ps-4">This control allows you to enter a search term. Can configure to make searchable, filterable, and select the searched item on tab.</div>
          <div class="col col-sm-6">            
            <v-select 
              style="font-size: 0.85rem"
              v-model="finClassDropDownSelectionsMultiple"
              :options="dropDownData" 
              :reduce="(item:DropDownDataType) => item.finClassId" label="finClassDescription" 
              :multiple="true" 
              :searchable="true"
              :filterable="true"
              :closeOnSelect="false"
              :select-on-tab="true" />
          </div>
        </div>
        <div class="mb-1">
          Drop Down Selections: {{ finClassDropDownSelectionsMultiple }}
        </div>
      </SectionPanel>

      <SectionPanel title="Pagination Buttons">
        <PaginationButtons 
          v-model:currentTopItem="compData.currentTopItem"
          :totalItems="10" 
          :itemsPerPage="3" />

        <div>
          totalItems to page over = 10<br>
          itemsPerPage = 3<br>
          compData.currentTopItem = {{ compData.currentTopItem }}
        </div>
      </SectionPanel>

      <SectionPanel title="Pagination">
        <Pagination  
          v-model:currentTopItem="compData.currentTopItemPag" 
          :data="tableData" 
          :itemsPerPage="3"
          :numberMaxPagesToDisplay="3"
        > 
          <template #item="{index, item}">
              <div v-bind:item="item">
                {{ item }}
              </div>
          </template>      
        </Pagination> 
        <div>
          itemsPerPage = 3<br>
          data is from tableData used in ChoiceTable above<br>
          compData.currentTopItemPag = {{ compData.currentTopItemPag }}
        </div>
      </SectionPanel>      

      <SectionPanel title="Tab">
        <Tab :value="TabPage.Page1" v-model="currentTab" :layout="LayoutOrientation.Horz">Page 1</Tab>
        <Tab :value="TabPage.Page2" v-model="currentTab" :layout="LayoutOrientation.Horz">Page 2</Tab>
        <Tab :value="TabPage.Page3" v-model="currentTab" :layout="LayoutOrientation.Horz">Page 3</Tab>
        <div style="border:1px solid grey">
          <div>
            <b>Content related to tab</b>
          </div>
          Current Tab Value: {{ currentTab }}
        </div>
      </SectionPanel>

      <SectionPanel title="EmailInput">
        <EmailInput v-model="userEmail" />
        <MessageBadge>
          Email: {{ userEmail }}
        </MessageBadge>
      </SectionPanel>      

      <SectionPanel title="PhoneInput & PhoneWithDetailsInput">
        <div class="mb-2">
          Phone Number Only (10 digits)
          <PhoneInput v-model="phoneNumber10Digits" title="10 Digit Number"/>
          <MessageBadge>
            Phone Number: {{ phoneNumber10Digits }}
          </MessageBadge>        
        </div>

        <div>
          With extension
          <PhoneWithDetailsInput title="Patient Phone" v-model:phone="phoneNumberWithExt.phone" v-model:extension="phoneNumberWithExt.ext" :showPhoneDescription="false"/>
          <MessageBadge>
            Number &amp; Ext: {{ phoneNumberWithExt }}
          </MessageBadge>
        </div>

        <div>
          With extension and description
          <PhoneWithDetailsInput v-model:phone="phoneNumberWithExt.phone" v-model:extension="phoneNumberWithExt.ext" v-model:phoneDescription="phoneNumberWithExt.desc"/>
          <MessageBadge>
            Number &amp; Ext: {{ phoneNumberWithExt }}
          </MessageBadge>
        </div>

      </SectionPanel>

      <SectionPanel title="Row">
        <Row>
            Left/Default
            <template #center>
              Center
            </template>
            <template #right>
              Right
            </template>
        </Row>
      </SectionPanel>

      <SectionPanel title="Icon">
        <div>
            Font Awesome: 
            <Icon :icon="IconTypes.Download" :displayStyle="DisplayStyle.Primary" :endingPadding="2" />
            <Icon :icon="IconTypes.View" :displayStyle="DisplayStyle.Primary" />
        </div>
        <div>
            Material: 
            <Icon :icon="IconTypes.Download" :iconFamily="IconFamily.Material" :endingPadding="2" />
            <Icon :icon="IconTypes.View" :iconFamily="IconFamily.Material" :displayStyle="DisplayStyle.Info" />
        </div>
      </SectionPanel>

      <SectionPanel title="PostalCode">
        <MessageText :displayStyle="TextDisplayStyle.Muted">
          You can allow Canadian Postal Codes via the allowCanadian property
        </MessageText>

        <PostalCode v-model="postalCode" :allowCanadian="true"  />
        <MessageBadge>
          Postal Code: {{ postalCode }}
        </MessageBadge>
      </SectionPanel>

      <SectionPanel title="GeographicStateSelect.vue">
        <MessageText :displayStyle="TextDisplayStyle.Muted">
          By default we display US States, Territories, "special" Miliary/Goverment locations.  You can also enable Canada Provinces.
        </MessageText>

        <GeographicStateSelect v-model="stateOrProvince" :canadianProvinces="true" />
        <MessageBadge>
          Selected Value: {{ stateOrProvince }}
        </MessageBadge>
      </SectionPanel>

      <SectionPanel title="WindowSearch.vue">
            <WindowSearchRendering v-model="compData.searchRenderingValue" label="Rendering" :newLink="true" />
            {{ compData.searchRenderingValue }}<br/>
            <WindowSearchPatient v-model="compData.searchPatientValue" label="Patient"/>
            {{ compData.searchPatientValue }}

      </SectionPanel>
 

    </div>
  </div>
</template>

<style scoped>
  .section{
    margin-bottom: 1em;
    font-size: x-large;
    color: cadetblue;
  }
</style>